<div class="userView">
  <div *ngIf="auth.user | async as user; else showLogin">
    <h1>Hello {{ user.displayName }}!</h1>
    <button (click)="logout()">Logout</button>
  </div>
</div>

<ng-template #showLogin>
  <p>Please login.</p>
  <form name="loginform" method="post" #formCtrl="ngForm">
    <div class="form-group">
      <label for="exampleInputEmail1">Email address</label>
      <input type="email" class="form-control" [(ngModel)]="user.email" placeholder="Email" [ngModelOptions]="{standalone:true}" required>
    </div>
    <div class="form-group">
      <label for="exampleInputPassword1">Password</label>
      <input type="password" class="form-control" [(ngModel)]="user.password" placeholder="Password" [ngModelOptions]="{standalone:true}" required>
    </div>
    <div *ngIf="loginError" class="alert alert-danger">{{ loginError }}</div>
    <div class="form-group">
      <button type="button" class="btn btn-primary btn-block" style="margin-bottom: 20px" (click)="signInWithEmail()" [disabled]="formCtrl.form.invalid">
        Login with Email
      </button>
    </div>
  </form>
</ng-template>
